import { Modal } from '@mantine/core';

import AssetsPicker from '../Assets/AssetsPicker';

// `zIndex` is only needed when this picker is rendered inside another Modal - both default to the
// same layer, so the picker would otherwise open behind its parent.
// `tab` ('images' | 'documents') narrows the listing server side; omitted, every asset is listed.
const AssetPickerModal = ({ show, pickUrl, confirm, close, zIndex, tab, title = 'Pick Image', assetFilter }) => {
  return (
    <Modal size="lg" opened={show} onClose={() => close()} title={title} zIndex={zIndex}>
      <AssetsPicker
        pickUrl={pickUrl}
        tab={tab}
        assetFilter={assetFilter}
        addAsset={(asset, siteUrl) => confirm(asset, siteUrl, close)}
        cancel={close}
      />
    </Modal>
  );
};

export default AssetPickerModal;
